import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./responsive.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ManageContextProvider from "./components/MangeContextProvide";
import { DashboardProvider } from "./components/AWBDashboard/DashboardContext/DashboardContext";


const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>

    <ManageContextProvider>
      <DashboardProvider>
        <App />
      </DashboardProvider>
    </ManageContextProvider>

  </React.StrictMode >
);

reportWebVitals();
